const data = require('../../../data');
const sharedState = (() => {
    const SharedState = require('../../../vueToAnim/SharedState');
    return SharedState.instance();
})();
const map = data.quiz.map;
const results = data.quiz.results;

let questions = data.quiz.locations.map(item => item.questions);
questions.unshift([]);
questions = questions.reduce((accumulator, increment) => {
    return accumulator.concat(increment);
});
const questionsIds = questions.map(item => item.id);

const questionsAnswers = questions.map(item => {
    return item.options.map(item => item.id).join('_');
});

const questionsAnswersById = questions.map(item => {
    const answers = {};
    let i;
    let option;
    for (i = 0; i < item.options.length; i++) {
        option = item.options[i];
        answers[option.id] = option;
    }
    return answers;
});

results.sort((a, b) => {
    return a.max - b.max;
});

export default {
    namespaced: true,
    state: {
        totalScore: 0,
        numQuestions: questions.length,
        numAnsweredQuestions: 0,
        currentQuestion: -1,
        answers: {},
        answersArray: [],
        complete: false,
        error: false,
        lastAnswer: '',
        lastIncrement: 0
    },
    getters: {
        totalScore: state => state.totalScore,
        numQuestions: state => state.numQuestions,
        numAnsweredQuestions: state => state.numAnsweredQuestions,
        getAnswer: state => {
            return id => {
                return state.answers[id];
            };
        },
        result: state => {
            let i;
            for (i = results.length - 1; i > -1; i--) {
                if (results[i].max < state.totalScore) break;
            }
            i++;
            if (i > results.length - 1) i = results.length - 1;
            return results[i];
        }
    },
    mutations: {
        answer(state, payload) {
            const nextIndex = state.answersArray.length;

            /* The Quiz is complete */
            if (nextIndex > this.numQuestions - 1) {
                state.complete = true;
                return;
            }

            /* The wrong Question */
            if (payload.questionId !== questionsIds[nextIndex]) {
                state.error = true;
                return;
            }

            /* There's no such an answer for the current question */
            if (!questionsAnswers[nextIndex].includes(payload.answerId)) {
                state.error = true;
                return;
            }

            /* There's no score data for this answer */
            if (!payload.answerId || typeof map[payload.answerId] === 'undefined') {
                state.error = true;
                return;
            }

            state.lastAnswer = payload.answerId;
            sharedState.lastAnswer = payload.answerId;

            const a = questionsAnswersById[nextIndex][payload.answerId];
            sharedState.lastAnswerName = a ? a.name : '';

            state.lastIncrement = map[state.lastAnswer] || 0;
            state.answers[payload.questionId] = payload.answerId;
            state.answersArray.push(payload.answerId);
            state.numAnsweredQuestions++;
            state.totalScore += map[payload.answerId];

            if (state.currentQuestion + 1 >= state.numQuestions) {
                state.complete = true;
            }
        },
        nextQuestion(state) {
            if (state.currentQuestion + 1 >= state.numQuestions) {
                state.complete = true;
                return;
            }
            state.currentQuestion++;
        },
        reset(state) {
            state.totalScore = 0;
            state.numQuestions = questions.length;
            state.numAnsweredQuestions = 0;
            state.currentQuestion = -1;
            state.answers = {};
            state.answersArray = [];
            state.complete = false;
            state.error = false;
        }
    },
    actions: {
        reset({commit}) {
            commit('reset');
        },
        nextQuestion({commit}) {
            commit('nextQuestion');
        },
        answer({commit}, payload) {
            commit('answer', payload);
        }
    }
};
